import { FormGroup } from '@angular/forms';
import { PatientEditInfo } from '../../model/patient/patient-edit-info';
import { setValidControl, setInValidControl } from '../validaror-invalid-control';
import { ReferringPhysicianEditInfo } from '../../model/referring-physician/referring-physician-edit-info';

export function referringPhysicianValidator(control: FormGroup) {
    if (control.value) {
        let valid  = control.valid;
        const physician = <ReferringPhysicianEditInfo>control.getRawValue();

        if ( !physician.NationalRegistration 
            && !physician.ProvincialRegistration
            && !physician.SpecialityRegistration ) {
            control.controls['NationalRegistration'].setErrors({ 'invalidOneRegistrationRequired': true });
            control.controls['ProvincialRegistration'].setErrors({ 'invalidOneRegistrationRequired': true });
            control.controls['SpecialityRegistration'].setErrors({ 'invalidOneRegistrationRequired': true });
            valid = false;
        }

        if (valid) {
            setValidControl(control.controls['NationalRegistration']);
            setValidControl(control.controls['ProvincialRegistration']);
            setValidControl(control.controls['SpecialityRegistration']);
            return null;
        } else {
            return  { 'invalidReferringPhysician': valid };
        }
    } else {
        return null;
    }
}
